export enum ScrollDirection {
  UP,
  NONE,
  DOWN,
}

export function computeScrollDirection(lastPosition: number, currentPosition: number, maxScroll: number): ScrollDirection {
  const lastY = Math.min(Math.max(0, lastPosition), maxScroll);
  const currentY = Math.min(Math.max(0, currentPosition), maxScroll);

  if (lastY > currentY) return ScrollDirection.UP;
  if (lastY < currentY) return ScrollDirection.DOWN;
  return ScrollDirection.NONE;
}
